import { render, staticRenderFns } from "./CookieMessage.vue?vue&type=template&id=2325b58b&scoped=true&lang=pug&"
import script from "./CookieMessage.vue?vue&type=script&lang=js&"
export * from "./CookieMessage.vue?vue&type=script&lang=js&"
import style0 from "./CookieMessage.vue?vue&type=style&index=0&id=2325b58b&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2325b58b",
  null
  
)

export default component.exports